import React from 'react';
import { FiInfo } from 'react-icons/fi';
import { UncontrolledTooltip } from 'reactstrap';

const QueueInfo = ({ agent, canSeePenalty }) => {
  return (
    <>
      <FiInfo
        size="1.5rem"
        id={`tooltip-${agent.extension}`}
        style={{ cursor: 'pointer' }}
      />
      <UncontrolledTooltip
        placement="top"
        target={`tooltip-${agent.extension}`}
        style={{ width: 'auto' }}
      >
        {agent &&
          agent.queues.map((q) => (
            <span
              style={{ whiteSpace: 'nowrap' }}
              key={q.id}
              className="d-block"
            >
              {q.name}
              {canSeePenalty ? ` - ${q?.penalty ?? 0}` : ''}
            </span>
          ))}
      </UncontrolledTooltip>
    </>
  );
};

export default QueueInfo;
